import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { UseTabsStateResult } from './hook';

export const {
	Context: StarterDashboardV2TabsStateContext,
	Provider: StarterDashboardV2TabsStateContextProvider,
	useContext: useStarterDashboardV2TabsStateContext,
} = createMandatoryContext<UseTabsStateResult>(undefined, {
	name: 'StarterDashboardV2TabsStateContext',
	processProviderProps: (props) => ({ ...props.value }),
});

export type StarterDashboardV2PageTabsState = ReturnType<typeof useStarterDashboardV2TabsStateContext>;
